import React, { useState } from "react";
import "./ProductImageCarousel.css";

const ProductImageCarousel = ({ images, thumbnails }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleThumbnailClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <div className="product-image-carousel-container">
      <div className="thumbnail-container">
        {thumbnails.map((thumb, index) => (
          <img
            src={thumb}
            className={`thumbnail-img ${activeIndex === index ? "active" : ""}`}
            alt={`Thumbnail ${index + 1}`}
            key={index}
            onClick={() => handleThumbnailClick(index)}
          />
        ))}
      </div>
      <div id="carouselExampleControls" className="carousel slide carousel-container">
        <div className="carousel-inner">
          {images.map((image, index) => (
            <div
              className={`carousel-item ${index === activeIndex ? "active" : ""}`}
              key={index}
            >
              <img src={image} alt={`Product ${index + 1}`} className="carousel-image" />
            </div>
          ))}
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleControls"
          data-bs-slide="prev"
          onClick={() =>
            setActiveIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1))
          }
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleControls"
          data-bs-slide="next"
          onClick={() =>
            setActiveIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1))
          }
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
};

export default ProductImageCarousel;